export default "__VITE_ASSET__CaW8xeSd__"